import type { CSSProperties, ReactNode } from 'react';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { css } from '@sorare/css';

import bg from './assets/bg.svg';

type Props = {
  children: ReactNode;
};

const hexagon = css`
  background-image: var(--hexagon-image);
  background-size: contain;
  background-repeat: no-repeat;
  width: var(--triple-unit);
  height: var(--triple-unit);
`;

export const BreakdownIcon = ({ children }: Props) => {
  return (
    <Horizontal
      center
      className={hexagon}
      style={{ '--hexagon-image': `url(${bg})` } as CSSProperties}
    >
      <LabelS color="var(--c-nd-600)" bold>
        {children}
      </LabelS>
    </Horizontal>
  );
};
